import { gql, useMutation } from '@apollo/client';

import { ONBOARDING_FAMILY_FRAGMENT } from '../queries/useOnboardingState';

import type { LinkDependantsMutation, LinkDependantsMutationVariables } from './__generated__/useLinkDependants.gql';

const LINK_DEPENDANTS = gql`
  mutation LinkDependants($input: LinkDependantsInput!) {
    linkDependants(input: $input) {
      ...OnboardingFamilyFragment
    }
  }
  ${ONBOARDING_FAMILY_FRAGMENT}
`;

/**
 * Creates a `DependantPartnership` row between two dependants. Returns the
 * parent `Family` so Apollo's cache picks up the new partnership row on
 * the queries that observe `Family.dependantPartnerships` — no manual
 * refetch needed.
 */
export const useLinkDependants = () => {
  return useMutation<LinkDependantsMutation, LinkDependantsMutationVariables>(LINK_DEPENDANTS);
};
